import { SolanaWithSignerBaseCommand } from '../../../../solana';

import { web3 } from '@coral-xyz/anchor';
import { Flags } from '@oclif/core';
import { Queue, SwitchboardPermission } from '@switchboard-xyz/on-demand';

export default class PermissionSet extends SolanaWithSignerBaseCommand {
  static description = 'set a switchboard on-demand permission';

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
    granter: Flags.string({
      description: 'public key of the granter account',
      required: true,
    }),
    grantee: Flags.string({
      description: 'public key of the grantee account',
      required: true,
    }),
    disable: Flags.boolean({
      description: 'disable the specified permission',
    }),
  };

  static args = {};

  async run() {
    // == begin flags&opts - setup and parse flags and default options
    const { flags } = await this.parse(
      this.constructor as typeof PermissionSet
    );

    // set default value = false => is not a Disable action
    const isDisableAction = flags.disable === true;
    // == end flags&opts

    const program = await this.program;

    const latestBlockhash =
      await this.connection.getLatestBlockhash('confirmed');
    console.log(
      '✅ - Fetched latest blockhash. Last Valid Height:',
      latestBlockhash.lastValidBlockHeight
    );

    // == begin queue - build queue and oracle objects
    const queueAccount = new Queue(program, new web3.PublicKey(flags.granter));
    const oracleKey = new web3.PublicKey(flags.grantee);
    // == end queue

    // == begin authority - check that the queueAuthority is the same as the specified keypair
    const queueData = await queueAccount.loadData();
    const queueAuthority = queueData.authority;

    // == begin isGuardian - check if Guardian
    // set native Program auth
    const nativeProgramAuth = '11111111111111111111111111111111';

    if (queueAuthority.toString() === nativeProgramAuth.toString()) {
      // native programs' auth is always '111111...'
      console.log(
        'ERROR: granter queue is a guardianQueue, use the `solana on-demand guardian register` command.'
      );
      return;
    }
    // == end isGuardian

    if (!this.keypair.publicKey.equals(queueAuthority)) {
      console.log('ERROR: queueAccount and authority are not the same');
      console.log(`>${queueAuthority}< !== >${this.keypair.publicKey}<`);
      return;
    }
    // -- end authority

    // == begin ix - craft the ix
    const ix = await queueAccount.setOraclePermissionIx({
      oracle: oracleKey,
      permission: SwitchboardPermission.PermitOracleHeartbeat,
      enable: !isDisableAction,
    });
    if (this.verbose) {
      console.log('  Adding the instruction below to the transaction:');
      console.log(
        `  Clear-text instruction: ${JSON.stringify(ix, undefined, 2)}`
      );
    }
    // == end ix

    await this.signAndSend([ix]);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, 'failed to set permission');
  }
}
